export const parseJson = (json, defaultValue) => {
    let response = null;
    try {
        response = JSON.parse(json);
    } catch (e) {
        response = null;
    }
   return response || defaultValue;
}

export const camelize = function(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

export function initialName(words) {
    if(words == null) return ''
    return words
      .replace(/\b(\w)\w+/g, '$1.')
      .replace(/\s/g, '')
      .replace(/\.$/, '')
      .toUpperCase();
}

export const toObject = (arr, keyField) =>{
    return arr.reduce((obj, item) => {
        obj[item[keyField]] = item
        return obj
    }, {})
}


export function findUnusedKeys(target, source) {
    let unused = [];
    for (let key in source) {
        if (target[key] === undefined) {
            unused.push(key);
        }
    }
    return unused;
}

export function logUnusedKeys(type, target, source) {
    let unused = findUnusedKeys(target, source);
    if (unused.length > 0) {
        console.warn(`Unused keys for type ${type}: `, unused);
    }
    return target;
}

export function isEmptyList(list) {
    return list == null || list.length === 0;
}


// ---------------------------------------------------------------------
// Desk ordering — group by region (FR first, then AU, then CA, then any
// others), case-insensitive, with natural numeric order within a region
// (so "Desk 1" < "Desk 2" < "Desk 10"). Region = the trailing 2-letter code.
// ---------------------------------------------------------------------
const DESK_REGION_ORDER = ['FR', 'AU', 'CA'];

export function deskRegion(name) {
    const m = String(name == null ? '' : name).trim().toUpperCase().match(/([A-Z]{2})\s*$/);
    return m ? m[1] : '';
}

export function compareDesks(a, b) {
    const ra = DESK_REGION_ORDER.indexOf(deskRegion(a));
    const rb = DESK_REGION_ORDER.indexOf(deskRegion(b));
    const rankA = ra === -1 ? DESK_REGION_ORDER.length : ra;
    const rankB = rb === -1 ? DESK_REGION_ORDER.length : rb;
    if (rankA !== rankB) return rankA - rankB;
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}

export function sortDesks(desks) {
    return [...(desks || [])].sort(compareDesks);
}

// Builds a vue-select option list grouped under desk headers. Header rows are
// flagged with `_isGroup: true` (render them distinctly + mark non-selectable
// via `:selectable="o => !o._isGroup"`). Groups are ordered by desk region,
// items within a group by their label (natural, case-insensitive).
//   items    - array of objects (orgs / business units / users …)
//   deskOf   - (item) => desk name string
//   labelOf  - (item) => string used to sort items within a group
export function groupItemsByDesk(items, deskOf, labelOf) {
    const map = new Map();
    (items || []).forEach(it => {
        const desk = (deskOf(it) || '').trim();
        const key = desk || '￿';
        if (!map.has(key)) map.set(key, { desk, items: [] });
        map.get(key).items.push(it);
    });
    const groups = [...map.values()].sort((a, b) => compareDesks(a.desk, b.desk));
    const out = [];
    groups.forEach(g => {
        out.push({ _isGroup: true, id: '__deskgrp__' + (g.desk || 'none'), name: g.desk || 'No Desk' });
        g.items
            .sort((a, b) => String(labelOf(a) == null ? '' : labelOf(a))
                .localeCompare(String(labelOf(b) == null ? '' : labelOf(b)), undefined, { numeric: true, sensitivity: 'base' }))
            .forEach(it => out.push(it));
    });
    return out;
}


// Returns a function, that as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being executed for
// `wait` milliseconds.
// https://skilled.dev/course/debounce
export const Debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

